import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { auth, database } from "../../database/firebase";
import "./login.css";
import logo from "./traceai_logo.png";

function Login() {
  const [user, setUser] = useState({
    email: "",
    password: "",
  })

  const [showPassword, setShowPassword] = useState(false);

  const history = useHistory();
  useEffect(() => {

    return () => {
      if (history.action === "POP") {
        // Code here will run when back button fires. Note that it's after the `return` for useEffect's callback; code before the return will fire after the page mounts, code after when it is about to unmount.
        history.push("");
      }
    }
  }, [history, history.action]);


  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser((prevState) => ({
      ...prevState,
      [name]: value
    }));
  }

  const {
    email,
    password
  } = user;

  const handleSubmit = async () => {

    if (!email || !password) {
      alert("All fields required");
    } else {
      await auth
        .signInWithEmailAndPassword(email, password)
        .then((currentUser) => {
          let uid = JSON.stringify(currentUser.user.uid);
          localStorage.setItem("uid", uid);

          if (uid) {

            database.child(`users/${JSON.parse(uid)}/role`).once("value", (snap) => {
              let data = snap.val(); //admin
              console.log(data)
              localStorage.setItem("role", data);

              if (data === "superadmin" || data === "superview") {
                history.push("/usercatchhistory");
              } else {

                history.push("/newcatch");
              }
            })
          };


        })
        .catch((err) => {
          alert(err.message);
        });
    }
  };


  return (
    <div>

      <div className="min-h-screen bg-gray-100 py-6 flex flex-col items-center justify-center sm:py-12">
        <div className="relative py-3 sm:max-w-xl sm:mx-auto">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900 to-light-blue-500 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl"></div>
          <div className="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">
            <div className="max-w-md mx-auto">


              <div className="text-left space-y-2 sm:text-left">
                <div className="space-y-0.5">
                  <p className="text-lg text-blue-900 font-sans font-bold">
                    You are now at
                  </p>
                </div>

                <div>
                  <img src={logo} alt="logo" className="mb-6" />
                </div>

              </div>
              <div>
                <p> Email Address</p>
                <input
                  type="email"
                  placeholder="Your Email Address"
                  name="email"
                  id="email"
                  onChange={handleChange}
                  className="my-3 flex-1 appearance-none border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                />
                <p> Password</p>
                <div className="flex justify-between items-center">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Your Password"
                    name="password"
                    id="password"
                    onChange={handleChange}
                    className="my-3 flex-1  appearance-none  border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />
                  <div
                    onClick={() => setShowPassword(!showPassword)}
                    className=" hover:text-blue-800 rounded px-2 py-1 text-sm text-gray-600 font-mono cursor-pointer"
                    htmlFor="toggle">

                    {showPassword ?
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                      </svg>
                      :
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>}
                  </div>
                </div>
                <div className="text-center">
                  <button
                    onClick={handleSubmit}
                    type="submit"
                    className="my-4 w-full bg-blue-600 text-white text-base font-normal py-2 px-4 mt-2 rounded-lg shadow-md hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200">
                    Sign In</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Login;


